import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Scorecard from './pages/Scorecard';
import History from './pages/History';
import Analytics from './pages/Analytics';
import EloHistory from './pages/EloHistory';
import TeamMaker from './pages/TeamMaker';
import Other from './pages/Other';
import SatHistory from './pages/SatHistory';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Analytics />} />
        <Route path="/scorecard" element={<Scorecard />} />
        <Route path="/history" element={<History />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/elo-history" element={<EloHistory />} />
        <Route path="/other" element={<Other />} />
        <Route path="/team-maker" element={<TeamMaker />} />
        <Route path="/sat-history" element={<SatHistory />} />
      </Routes>
    </Layout>
  );
}

export default App;
